import { HttpContextToken } from '@angular/common/http';

export const NO_ERROR_HANDLER = new HttpContextToken(() => true);
